import { render, staticRenderFns } from "./ConfiguracionSatisfaccion.vue?vue&type=template&id=796767d1&"
import script from "./ConfiguracionSatisfaccion.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionSatisfaccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports